<template>
  <a-modal
    title="导入第三方产品"
    :visible="visible"
    @ok="addAlibaba()"
    @cancel="cancel()"
    width="540px"
  >
    <a-form-model ref="ruleForm" :model="form" :rules="rules" v-bind="layout">
      <a-form-model-item
        ref="platform_type"
        label="店铺类型"
        prop="platform_type"
      >
        <a-select
          v-model="form.platform_type"
          class="seachs"
          allowClear
          placeholder="请选择"
          @change="
            (e) => {
              $refs.ruleForm.clearValidate('platform_type');
              formErr.platform_type = '';
            }
          "
        >
          <a-select-option
            :value="item.id"
            :key="index"
            v-for="(item, index) in platformTypeList"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item
        ref="detail_url"
        label="产品地址"
        prop="detail_url"
        :help="formErr.detail_url"
        :validateStatus="
          !formErr.detail_url || formErr.detail_url === '' ? '' : 'error'
        "
      >
        <a-input
          type="textarea"
          :rows="4"
          placeholder="http://"
          v-model="form.detail_url"
          @change="
            (e) => {
              formErr.detail_url = '';
            }
          "
          @blur="
            (e) => {
              form.detail_url = e.target.value.trim();
            }
          "
        />
      </a-form-model-item>
    </a-form-model>
    <div style="position: relative;">
      <span style="position: absolute; top: 0; left: 0;">注：</span>
      <div style="padding-left: 30px;">
        1.请输入{{
          form.platform_type === 1 ? "阿里" : "Made in China"
        }}产品详情页链接地址；如有多个，换行输入。<br />
        2.最多可输入100行。超出将自动截取<br />
        3.导入后图片水印跟随用户后台“产品管理-水印设置”，如果不想添加水印，请关闭水印，如果想要添加水印，请开启并上传水印
      </div>
    </div>
  </a-modal>
</template>

<script>
import API from "../api";
import { debounce, validator } from "@/utils/utils";

export default {
  name: "index",
  data() {
    return {
      layout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 18 }
      },
      platformTypeList: [
        { id: 1, name: "阿里巴巴" },
        { id: 2, name: "Made in China" }
      ],
      visible: false,
      form: {
        platform_type: 1,
        detail_url: ""
      },
      formErr: {
        platform_type: "",
        detail_url: ""
      },
      rules: {
        platform_type: [
          {
            required: true,
            message: "请选择店铺类型",
            trigger: "blur"
          },
          {
            validator: (rule, value, callback) => {
              validator(rule, value, callback, this.formErr.platform_type);
            },
            trigger: "blur"
          }
        ],
        detail_url: [
          {
            required: true,
            message: "请输入产品地址",
            trigger: "blur"
          },
          {
            validator: (rule, value, callback) => {
              let val = value.split("\n");
              if (val.length > 100) {
                this.formErr.detail_url = "超出100行，已自动截取";
                this.form.detail_url = val.slice(0, 100).join("\n");
              }
              validator(rule, value, callback, this.formErr.detail_url);
            },
            trigger: "change"
          }
        ]
      }
    };
  },
  props: {
    seachData: {
      type: Object,
      default: () => {}
    }
  },
  components: {},
  computed: {},
  created() {},
  mounted() {},
  methods: {
    cancel() {
      this.visible = false;
      this.formErr = {
        platform_type: "",
        detail_url: ""
      }
      if (this.$refs.ruleForm) this.$refs.ruleForm.resetFields();
    },
    addAlibaba() {
      let _that = this;
      this.$refs.ruleForm.validate((valid) => {
        let paramErr = JSON.parse(JSON.stringify(_that.formErr));
        if (
          valid ||
          (paramErr.platform_type == "" &&
            paramErr.detail_url == "超出100行，已自动截取")
        ) {
          setTimeout(() => {
            API.service
              .DETAIL_ADDPOST({
                platform_type: _that.form.platform_type,
                detail_url: _that.form.detail_url,
                a_customer_id: _that.seachData.id
              })
              .then((res) => {
                if (res.data.code === 400) {
                  _that.$refs.ruleForm.clearValidate();
                  res.data.msg.map((item) => {
                    _that.formErr[item.field] = item.msg;
                  });
                } else if (res.data.code === 200) {
                  this.cancel();
                  _that.$emit("refresh");
                }
              });
          }, 300);
        }
      });
    }
  }
};
</script>
<style scoped></style>
